// JS
import React from 'react';
import { renderHTML } from '../shared/utils';

// COMPONENT
const ProductReturns = ({ data }) => {
  return (
    <div className={'product-returns'} id="product-returns-content-panel">
      {data && (
        <div className="product-returns-container" key={data.contentguid}>
          <div className="product-returns-content">
            <h3 className="product-returns-title">{data.uk_returns_title}</h3>
            <div className="product-returns-body">
              {renderHTML(data.uk_returns_content)}
            </div>
            <div className="product-returns-helphub">
              {renderHTML(data.returns_help_hub)}
            </div>
          </div>
          <div className="product-returns-content">
            <h3 className="product-returns-title">
              {data.international_returns_title}
            </h3>
            <div className="product-returns-body">
              {renderHTML(data.international_returns_content)}
            </div>
            <div className="product-returns-helphub">
              {renderHTML(data.returns_help_hub)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductReturns;
